<div id="scanner" class="loader_scan" [class.scan_fullscreen]="showFullScreen">
  <span id="invisibleScanBlock"></span>
  <div #scanner_wrapper [hidden]="!isLaser && (!started || qrResultString)" class="scanner_wrapper">
    <div id="scanner_placeholder">
      <div #scanner_square class="scanner_square"></div>
      <div *ngIf="this.availableDevices?.length > 1" class="scanner_bottom">
        <fa-icon icon="camera-rotate" (click)="nextCamera()" class="scanner_camera"></fa-icon>
      </div>
    </div>
    <div class="zxing-wrapper" [hidden]="!this.hasPermission" *ngIf="!isLaser">
      <zxing-scanner #zscanner
                     [(device)]="currentDevice"
                     [autostart]="true"
                     [enable]="true"
                     [autofocusEnabled]="true"
                     [previewFitMode]="'cover'"
                     (scanSuccess)="!qrResultString && onCodeResult($event)"
                     (scanComplete)="onScanComplete($event)"
                     (scanError)="scanError($event)"
                     (permissionResponse)="onHasPermission($event)"
                     (camerasFound)="onCamerasFound($event)"
                     (autostarted)="autoStarted()"
                     playsinline>
      </zxing-scanner>
    </div>
    <div class="laser-wrapper" *ngIf="isLaser">
      <fa-icon icon="bolt" class="laser-icon" *ngIf="!laserError"></fa-icon>
      <div class="laser-text" *ngIf="!laserError">{{'scanner.laser_scanning' | translate}}</div>
      <div class="laser-error" *ngIf="laserError">
        <fa-icon icon="exclamation-triangle" class="error-icon"></fa-icon>
        <div class="error-text">{{'scanner.laser_error' | translate}}</div>
        <button class="retry-button" (click)="retryLaser()">{{'scanner.laser_retry' | translate}}</button>
      </div>
    </div>
  </div>
  <ng-container class="loader_processing" *ngIf="qrResultString">
    <img src="assets/images/3-dots-scale.svg" alt="spinner" width="100" height="100">
    <div class="mt_20">{{'scanner.processing' | translate}}</div>
  </ng-container>
</div>
